import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Collapse, Typography, Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
    "& .MuiTypography-root": {
      marginBottom: theme.spacing(1),
    },
    "& .MuiAlert-icon": {
      marginLeft: theme.spacing(1),
    },
  },
}));

export default function AxiosErrorHandling(props) {
  const classes = useStyles();
  const [showDetails, setShowDetails] = React.useState(false);

  return (
    <div className={classes.root}>
      <Alert severity="error">
        <AlertTitle>
          <strong>{props.title}</strong>
        </AlertTitle>
        <Typography variant="body1">{props.error.data.code}</Typography>
        <Button variant="outlined" onClick={() => setShowDetails(!showDetails)}>
          {!showDetails ? "פרטים מלאים" : "הסתר פרטים"}
        </Button>
        <Collapse in={showDetails}>
          <Typography variant="body1">
            <strong>פרטי השגיאה</strong>
          </Typography>
          <Typography variant="body1">
            קוד שגיאה: {props.error.status}
          </Typography>
          <Typography variant="body1">
            פרטים טכניים: {props.error.data.code}
          </Typography>
          <Typography variant="body1">
            תוכן ההודעה: {props.error.data.message}
          </Typography>
        </Collapse>
      </Alert>
    </div>
  );
}
